/**
 * @param {Glider} glider
 * @param {HTMLElement} element
 * @param {Number} slideinterval
 */
export function registerAutoplay(glider, element, slideinterval) {
  const autoplayDelay = 1000 * slideinterval;
  let timeout = -1;
  let hovering = false;

  // eslint-disable-next-line no-inner-declarations
  function startTimeout() {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (!hovering) {
        glider.scrollItem((glider.slide + parseInt(glider.opt.slidesToShow, 10)) % glider.slides.length);
      }
    }, autoplayDelay);
  }

  let animID = 0;
  const isAnimating = () => glider.animate_id !== animID;
  element.addEventListener('glider-animated', () => {
    animID = glider.animate_id;
    if (!hovering) startTimeout();
  });

  element.addEventListener('mouseover', () => {
    hovering = true;
    clearTimeout(timeout);
  });

  element.addEventListener('mouseout', () => {
    hovering = false;
    if (!isAnimating()) startTimeout();
  });

  startTimeout();
}
